import AileronCta from '../components/sections/AileronCta';

export default function LifeSafetyAIPage() {
  return (
    <section className="mx-auto max-w-7xl px-6 py-10">
      <h1 className="text-3xl font-bold text-gray-900">LifeSafetyAI</h1>
      <p className="mt-3 max-w-3xl text-gray-600">
        LifeSafetyAI is a focused initiative for applying AI and automation to life safety workflows, documentation, and operational coordination.
      </p>

      <div className="mt-8 grid gap-6 md:grid-cols-3">
        <div className="rounded-2xl border border-gray-200 bg-white p-5">
          <h2 className="text-lg font-semibold text-gray-900">What it is</h2>
          <p className="mt-2 text-gray-600">
            A practical set of tools and patterns for reducing manual overhead in life safety related processes.
          </p>
        </div>

        <div className="rounded-2xl border border-gray-200 bg-white p-5">
          <h2 className="text-lg font-semibold text-gray-900">Who it helps</h2>
          <p className="mt-2 text-gray-600">
            Service companies, operations teams, and trade businesses that need reliable documentation and faster response cycles.
          </p>
        </div>

        <div className="rounded-2xl border border-gray-200 bg-white p-5">
          <h2 className="text-lg font-semibold text-gray-900">Use cases</h2>
          <p className="mt-2 text-gray-600">
            Field-to-office updates, report generation, task standardization, and process visibility for stakeholders.
          </p>
        </div>
      </div>
      <AileronCta
        title="Interested in LifeSafetyAI for your operation?"
        description="Start with a quick discussion to map where AI and workflow automation can remove your current bottlenecks."
      />
    </section>
  );
}
